<template>
	<div class="contain">
		<div style="box-sizing: border-box; padding: 15px 15px 50px">
			<div style="min-height: 80vh; background: #fff; border-radius: 12px">
				<vue-hash-calendar :visible.sync="isShowCalendar" ref="calendar" :themeColor="themeColor"
					:markType="'dot'" @change="calendarChange" :markDate="markDate" format="YY-MM-DD">
					<!-- :weekStart="'monday'" -->
					<!-- :disabled-week-view="true" -->
					<div slot="action" class="action">
						<div class="now">{{ year }}<span class="shu"></span>{{ now }}</div>
						<div slot="today" class="today" @click="backToday">回到今天</div>
					</div>
					<!-- 当前月份 字体加粗 -->
					<!-- <b slot="day" slot-scope="scope" class="no-weight">{{
              scope.date.day
            }}</b> -->
				</vue-hash-calendar>
				<div class="cardList">
					<div v-if="processList.length > 0">
						<h3 style="margin: 10px 0 0">打卡记录</h3>
						<el-timeline style="margin: 20px 0px 0 10px" v-if="processList.length > 0">
							<el-timeline-item v-for="(i, index) in processList" :key="index">
								<div class="clockTime" style="display: flex; align-items: center">
									<div>{{ i.time }}</div>
									<div v-if="i.status == 1" class="status">（补卡）</div>
									<div v-if="i.status == 2" class="status">（迟到）</div>
									<div v-if="i.status == 3" class="status">（早退）</div>
									<div v-if="i.status == 4" class="status">（未分配考勤组）</div>
									<div v-if="i.status == 5" class="status">（上班）</div>
									<div v-if="i.status == 6" class="status">（下班）</div>
									<div v-if="i.status == 7" class="status">（已覆盖）</div>
									<div v-if="i.status == 8" class="status">（外勤）</div>
								</div>
								<div class="clockType">{{ i.type }}</div>

								<div class="clockType" v-if="i.reason != null && i.reason != ''">外勤原因: {{ i.reason }}
								</div>

								<div class="clockType" v-if="i.reasonImg != null && i.reasonImg != ''">
									外勤打卡图片: <br />
									<img :src="i.reasonImg" alt="无图片" style="width: 100px; height: 100px;"
										@click="previewImage(i.reasonImg)" />
								</div>
								<!-- :timestamp="i.clockInTime" -->
								<!-- <div v-if="i.type == 1" class="clockTime">
                <div v-if="i.clockInTime">上班 {{ parseTime(i.clockInTime, '{h}:{i}') }}</div>
                <div v-if="!i.clockInTime">上班 未打卡</div>
              </div>
              <div v-if="i.type == 2" class="clockTime">
                <div v-if="i.clockInTime">下班 {{ parseTime(i.clockInTime, '{h}:{i}') }}</div>
                <div v-if="!i.clockInTime">下班 未打卡</div>
              </div>
              <div class="clockType" v-if="i.clockInType == 1">地点打卡</div>
              <div class="clockType" v-if="i.clockInType == 2">Wifi打卡</div>
              <div class="clockType" v-if="i.clockInType == 3">外勤打卡</div>
              <div class="clockType" v-if="i.clockInType == 3 && i.remark">外勤原因: {{ i.remark }}</div> -->
							</el-timeline-item>
						</el-timeline>
					</div>

					<!-- 申请记录 -->
					<div v-if="repairList.length > 0">
						<h3 style="margin: 10px 0 0">补卡记录</h3>
						<el-timeline style="margin: 20px 0px 0 10px">
							<el-timeline-item v-for="(i, index) in repairList" :key="index + 'repair'">
								<div class="clockTime">
									<div>{{ i.applyTime.slice(11) }}</div>
								</div>
								<div class="clockType">{{ i.applyReason }}</div>
								<div class="clockType" v-if="i.status == 0" style="color: #fbc21f">待审核</div>
								<div class="clockType" v-if="i.status == 1" style="color: #139659">通过</div>
								<div class="clockType" v-if="i.status == 2" style="color: #f04438">驳回</div>
							</el-timeline-item>
						</el-timeline>
					</div>
					<!-- 空状态 -->
					<div style="text-align: center; margin: 20px 0 40px">
						<div v-if="processList.length == 0">
							<img src="../../assets/image/empty.png" alt="" style="width: 50%" />
							<div class="today">当天没有打卡记录</div>
						</div>
						<div style="text-align: center; margin-bottom: 10px"
							:style="processList.length == 0 ? '' : 'border-top: 1px solid #f3f3f4'">
							<div style="margin-top: 10px">
								<span style="color: red" v-if="repairApplyNum == 0">剩余补卡次数{{ repairApplyNum }}</span>
								<span style="color: #56b855" v-else>剩余补卡次数{{ repairApplyNum }}</span>
							</div>
							<div style="margin-top: 10px">
								<van-button round type="info" style="padding: 0 30px" size="small" @click="repairApply"
									:disabled="repairApplyNum == 0">补卡申请</van-button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- <div class="line-turn" @click="isShowWeekView = !isShowWeekView">
          {{ isShowWeekView ? "周视图" : "月视图" }}
        </div> -->
		</div>

		<!--弹出框，赋予chargeBtn事件-->
		<!-- <van-dialog v-model="showDialog" show-cancel-button title="外勤原因" @confirm="confirm" @cancel="cancelDialog"> -->
		<!-- :beforeClose="cancelDialog" -->
		<!--输入框-->
		<!-- <van-field v-model="remark" rows="1" autosize label="原因" type="textarea" placeholder="请输入原因" />
		</van-dialog> -->
		<!-- 补卡申请 -->
		<van-popup v-model="repairDialog" show-cancel-button @close="cancelDialog" position="bottom">
			<div style="margin: 10px" class="repair">
				<h3 style="text-align: center; margin: 10px 0">补卡申请</h3>
				<!-- <van-field v-model="remark" label="补卡时间" readonly /> -->

				<div class="applyReason">
					<div style="padding: 6px 16px; color: #646566; font-size: 14px">
						<span style="color: red">*</span> 补卡时间
					</div>
					<div style="padding: 6px 16px; color: #646566; font-size: 14px">
						<el-time-picker v-model="repairForm.applyTime" placeholder="请选择补卡时间" class="applyReason"
							value-format="HH:mm:ss" style="z-index: 9999 !important; width: 100%">
						</el-time-picker>
					</div>
				</div>
				<div class="applyReason">
					<div style="padding: 2px 16px; color: #646566; font-size: 14px">原因</div>
					<van-field v-model="repairForm.applyReason" rows="3" autosize type="textarea" placeholder="请输入原因" />
				</div>
			</div>
			<div style="margin: 10px">
				<van-button round type="info" style="width: 100%" @click="repairConfirm">确认</van-button>
			</div>
		</van-popup>

		<van-tabbar v-model="active" @change="onChange">
			<van-tabbar-item name="打卡">
				<span>打卡</span>
				<template #icon="props">
					<img :src="props.active ? icon.active : icon.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item name="统计">
				<span>统计</span>
				<template #icon="props">
					<img :src="props.active ? icon.active2 : icon.inactive2" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
	import {
		getInfoByUserId,
		getTodayInfo,
		getUserInfo,
		clockIn,
		getZhuUlockRecord,
		getClockInByUserId,
		getClockInType,
		clockInField,
		unlockRecordDetailDay,
		addRepairApply,
		getRepairApplyList,
		getRepairApplyNum,
	} from '@/api/Industry'
	import {
		Toast,
		ImagePreview
	} from 'vant'
	export default {
		// 组件名称
		name: '',
		// 组件参数 接收来自父组件的数据
		props: {},
		// 局部注册的组件
		components: {},
		// 组件状态值
		data() {
			return {

				isOutPic: "", //图片

				count: 0,
				isLoading: false,
				showDialog: false,
				remark: '',
				isShowWeekView: false, //是否以周视图展示日历组件
				themeColor: {
					'bg-color': '#ffffff',
					'main-color': '#3b87f7',
					'main-font-color': '#333333',
					'vice-font-color': '#666666',
				}, //日历主体色
				month: '', // 当前月份
				day: '',
				now: '', //当前月.日
				year: '', //当前年份
				time: new Date(), //只接受中国标准时间
				markDate: [], //有标记的日期
				// markDate: [{ color: "#3b87f7", date: ["2024/04/25"] }], //有标记的日期
				markType: 'dot',
				isShowCalendar: false,
				loopCount: 0,
				maxLoopCount: 100,
				endTime: '', // 下班时间
				beginTime: '', // 下班时间
				gotoWork: false, // 上班打卡
				afterWork: false, // 下班打卡
				outWork: false, // 外勤打卡
				normalWork: false, // 正常上班打卡
				showShang: false, //
				showXia: false, //
				timer: null,
				timeDataStr: '', // 当前系统时间
				nowTimeData: 0,
				companyName: '',
				companyId: '',
				platformId: '',
				userId: '',
				Data: null,
				showCard: true,
				active: 1,
				icon: {
					active: 'https://points-malls.oss-cn-beijing.aliyuncs.com/goodsImg/7bfe.png',
					inactive: 'https://points-malls.oss-cn-beijing.aliyuncs.com/goodsImg/512e.png',
					active2: 'https://points-malls.oss-cn-beijing.aliyuncs.com/goodsImg/bdd9.png',
					inactive2: 'https://points-malls.oss-cn-beijing.aliyuncs.com/goodsImg/f252.png',
				},
				userDetial: {},
				processList: [],
				repairDialog: false, //补卡申请
				repairForm: {
					applyUserId: this.$route.params.userId,
					applyReason: '',
					applyTime: '',
				},
				repairList: [], //申请的补卡记录
				repairApplyNum: 0,
			}
		},
		// 计算属性
		computed: {},
		// 侦听器
		watch: {
			//月份变换时获取当前月份标记日期
			// now: {
			//   handler(newVal, oldVal) {
			//     // this.getMarkDate();
			//   },
			//   immediate: true,
			// },
			// year: {
			//   handler(newVal, oldVal) {
			//   },
			//   immediate: true,
			// },
		},
		filters: {
			returnFloat(val) {
				if (val.length <= 2) {
					return val
				} else {
					return val.slice(-2)
				}
			},
			formatTime(val) {
				return val.split(' ')[0]
			},
		},
		// 组件方法
		methods: {
			// 查看图片
			previewImage(imageUrl) {
				ImagePreview({
					images: [imageUrl],
				})
				// const img = new Image();
				// img.src = imageUrl;
				// const imgPreviewWindow = window.open('', '_blank', 'width=800,height=600');
				// imgPreviewWindow.document.write(`<img src="${imageUrl}" style="width: 100%; height: 100%;" />`);
			},

			onRefresh() {
				// this.initDate();
				setTimeout(() => {
					this.gotoUrl()
					this.getNowTimeFun()
					this.getUserInfo()
					this.getToday()
					this.isLoading = false
				}, 1000)
			},
			// 跳往统计页面
			gotoTj() {
				this.showCard = false
				this.isShowCalendar = true
				this.active = '统计'
			},
			// 获取统计 考勤打卡 列表
			getClockInByUserId() {
				unlockRecordDetailDay({
					userId: this.userId,
					day: this.day,
				}).then((res) => {
					if (res.code == 200) {
						console.log(res)
						this.processList = res.data
					}
				})
			},
			// 获取统计 考勤打卡 日期
			getStatisticsByDay() {
				getZhuUlockRecord({
					userId: this.userId,
					date: this.month,
				}).then((res) => {
					if (res.code == 200) {
						console.log(res)
						var list = res.data
						list.forEach((i) => {
							if (i.days <= this.parseTime(this.time, '{y}-{m}-{d}')) {
								if (i.count == 2) {
									this.markDate.push({
										color: '#3b87f7',
										date: [i.days],
									})
								} else {
									this.markDate.push({
										color: '#ffba00',
										date: [i.days],
									})
								}
							}
						})
					} else {
						Toast(res.msg)
					}
				})
			},
			//获取当前月份标记日期
			getMarkDate() {
				console.log(this.markList, 'this.markList[0].date')
				//通过修改this.markList[0].date来实现切换月份时获取对应的标记日期，格式为['2022/09/11','2022/09/12']之类
			},
			//回到今天
			backToday() {
				this.$refs.calendar.today()
			},
			//显示当前几月
			initDate() {
				this.year = this.$refs.calendar.checkedDate.year
				var m = this.$refs.calendar.checkedDate.month + 1
				var d = this.$refs.calendar.checkedDate.day
				if (m < 10) {
					m = '0' + m
				}
				if (d < 10) {
					d = '0' + d
				}
				this.now = m + '.' + d
				this.month = this.year + '-' + m
				this.day = this.year + '-' + m + '-' + d
				this.getStatisticsByDay()
				this.getClockInByUserId()
				this.getRepairApply()
        this.getRepairApplyNum();
			},
			//切换月份
			calendarChange(data) {
				this.initDate()
			},
			//选择日期
			selectDate(data) {
				console.log(data)
			},
			touchEnd(e) {
				console.log(e)
			},

			gotoUrl() {
				if (window.__wxjs_environment === 'miniprogram') {
					// 页面 不会重新加载
					window.wx.miniProgram.navigateTo({
						url: '../public/getLocation?companyName=' +
							this.companyName +
							'&platformId=' +
							this.platformId +
							'&userId=' +
							this.userId,
					})
					// this.loopCount = 0;
					// this.fun();
				} else {
					alert('请在微信小程序中打开')
					// 页面会 重新加载(如:列表页 查看详情后会返回顶部)
					// this.$router.push(path);
				}
			},
			confirm(e) {
				console.log(this.remark, "remark");
				console.log(this.isOutPic, "isOutPic");
				if (!this.remark) {
					Toast("请输入外勤原因");
					this.showDialog = true;
					return false;
				} else {
					this.ClockInField(this.remark, this.isOutPic);
					this.showDialog = false;
					this.remark = "";
					this.isOutPic = "";
				}
			},
			cancelDialog() {
				this.isOutPic = "";
				this.showDialog = false
				this.remark = '';
				this.repairDialog = false
				this.repairForm = {
					applyUserId: this.$route.params.userId,
					applyReason: '',
					applyTime: '',

				}
			},
			// 打卡 按钮
			clockButton() {
				if (this.outWork) {
					// 外勤打卡
					this.showDialog = true
				} else {
					// 正常打卡
					this.ClockIn()
				}
				// if (window.__wxjs_environment === "miniprogram") {
				//   // 页面 不会重新加载
				//   // window.wx.miniProgram.navigateTo({
				//   //   url:
				//   //     "../public/getLocation?companyName=" +
				//   //     this.companyName +
				//   //     "&platformId=" +
				//   //     this.platformId +
				//   //     "&userId=" +
				//   //     this.userId,
				//   // });
				//   this.loopCount = 0;
				//   this.fun();
				// } else {
				//   alert("请在微信小程序中打开");
				//   // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
				//   // this.$router.push(path);
				// }
			},
			fun() {
				getUserInfo({
					userId: this.userId,
					platformId: this.platformId,
				}).then((res) => {
					this.loopCount++
					// 判断是否有数据
					if (!res.data) {
						this.fun()
						this.Data = false
					} else {
						this.Data = true
						this.ClockIn()
					}
				})
			},

			// 正常打卡
			ClockIn() {
				clockIn({
					userId: this.userId,
					platformId: this.platformId,
					companyId: this.companyId,
				}).then((res) => {
					if (res.code == 200) {
						Toast.success('打卡成功')
						getInfoByUserId({
							userId: this.userId,
							platformId: this.platformId,
						}).then((res) => {
							console.log(res)
							if (res.code == 200) {
								if (!res.data) {
									console.log(1111)
									if (this.timeDataStr < '12:00:00') {
										console.log(333)
										// 上班
										this.gotoWork = true
										this.showShang = false
										this.showXia = false
									} else {
										// 下班
										this.afterWork = true
										this.showXia = false
										this.showShang = false
									}
								} else {
									console.log(222)
									// 下班
									this.afterWork = true
									this.showXia = false
									this.showShang = false
									if (res.data.clockInTime != null) {
										// res.data.clockInTime
										res.data.clockInTime = this.formatTime(res.data.clockInTime)
										this.showShang = true
									}
									if (res.data.endClockInTime != null) {
										// res.data.clockInTime
										res.data.endClockInTime = this.formatTime(res.data.endClockInTime)
										this.showXia = true
									}
									this.userDetial = res.data
								}
							} else {
								Toast(res.msg)
							}
						})
						this.gotoWork = false
						this.afterWork = false
					} else {
						console.log(23456)
						Toast(res.msg)
					}
				})
			},
			// 外勤打卡
			ClockInField(remark, isOutPic) {
				clockInField({
					userId: this.userId,
					platformId: this.platformId,
					companyId: this.companyId,
					remark: remark,
					isOutPic: isOutPic,
				}).then((res) => {
					if (res.code == 200) {
						Toast.success('打卡成功')
						getInfoByUserId({
							userId: this.userId,
							platformId: this.platformId,
						}).then((res) => {
							console.log(res)
							if (res.code == 200) {
								if (!res.data) {
									console.log(1111)
									if (this.timeDataStr < '12:00:00') {
										console.log(333)
										// 上班
										this.gotoWork = true
										this.showShang = false
										this.showXia = false
									} else {
										// 下班
										this.afterWork = true
										this.showXia = false
										this.showShang = false
									}
								} else {
									console.log(222)
									// 下班
									this.afterWork = true
									this.showXia = false
									this.showShang = false
									if (res.data.clockInTime != null) {
										// res.data.clockInTime
										res.data.clockInTime = this.formatTime(res.data.clockInTime)
										this.showShang = true
									}
									if (res.data.endClockInTime != null) {
										// res.data.clockInTime
										res.data.endClockInTime = this.formatTime(res.data.endClockInTime)
										this.showXia = true
									}
									this.userDetial = res.data
								}
							} else {
								Toast(res.msg)
							}
						})
					} else {
						// console.log(23456);
						Toast(res.msg)
					}
				})
			},
			getUserInfo() {
				console.log(this.timeDataStr)
				// 1. 先判断是外勤打卡 or 正常打卡
				getClockInType({
					userId: this.userId,
					platformId: this.platformId,
				}).then((res) => {
					console.log(res, 'res')
					if (res.code == 200) {
						if (res.data == 0) {
							// 外勤打卡
							this.outWork = true
							this.normalWork = false
						} else {
							this.outWork = false
							this.normalWork = true
						}
						// 2.正常上班 打卡(再判断是上班/下班 打卡)
						getInfoByUserId({
							userId: this.userId,
							platformId: this.platformId,
						}).then((res) => {
							console.log(res)
							if (res.code == 200) {
								if (!res.data) {
									console.log(1111)
									if (this.timeDataStr < '12:00:00') {
										console.log(333)
										// 上班
										this.gotoWork = true
										this.showShang = false
										this.showXia = false
									} else {
										// 下班
										this.afterWork = true
										this.showXia = false
										this.showShang = false
									}
								} else {
									console.log(222)
									// 下班
									this.afterWork = true
									this.showXia = false
									this.showShang = false
									if (res.data.clockInTime != null) {
										// res.data.clockInTime
										res.data.clockInTime = this.formatTime(res.data.clockInTime)
										this.showShang = true
									}
									if (res.data.endClockInTime != null) {
										// res.data.clockInTime
										res.data.endClockInTime = this.formatTime(res.data.endClockInTime)
										this.showXia = true
									}
									this.userDetial = res.data
								}
							} else {
								Toast(res.msg)
							}
						})
					}
				})
			},
			// 时间截取
			formatTime(timeStr) {
				const [, year, month, day, hour, minute, second] = timeStr.match(
					/(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/
				)
				return `${hour}:${minute}:${second}`
			},
			// 获取 上下班时间
			getToday() {
				getTodayInfo({
					userId: this.userId,
					platformId: this.platformId
				}).then((res) => {
					if (res.code == 200) {
						console.log(res)
						this.beginTime = res.data.beginTime
						this.endTime = res.data.endTime
					} else {
						Toast(res.msg)
					}
				})
			},
			// 定时器
			getTime() {
				var that = this
				that.nowTimeData = that.nowTimeData + 1000
				that.timeDataStr = that.parseTime(that.nowTimeData, '{h}:{i}:{s}')
				this.timer = setInterval(() => {
					that.nowTimeData = that.nowTimeData + 1000
					that.timeDataStr = that.parseTime(that.nowTimeData, '{h}:{i}:{s}')
				}, 1000)
			},

			// 获取当前系统页面时间
			getNowTimeFun() {
				this.nowTimeData = new Date().getTime()
				this.getTime()
			},
			parseTime(time, cFormat) {
				if (time.length === 0) {
					return null
				}
				const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
				let date
				if (typeof time === 'object') {
					date = time
				} else {
					if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
						time = parseInt(time)
					}
					if (typeof time === 'number' && time.toString().length === 10) {
						time = time * 1000
					}
					date = new Date(time)
				}
				const formatObj = {
					y: date.getFullYear(),
					m: date.getMonth() + 1,
					d: date.getDate(),
					h: date.getHours(),
					i: date.getMinutes(),
					s: date.getSeconds(),
					a: date.getDay(),
				}
				const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
					let value = formatObj[key]
					// Note: getDay() returns 0 on Sunday
					if (key === 'a') {
						return ['日', '一', '二', '三', '四', '五', '六'][value]
					}
					if (result.length > 0 && value < 10) {
						value = '0' + value
					}
					return value || 0
				})
				return time_str
			},
			onChange(val) {
				console.log(val)
				this.active = val
				if (val == '打卡') {
					if (window.__wxjs_environment === 'miniprogram') {
						// 页面 不会重新加载
						window.wx.miniProgram.redirectTo({
							url: '../clockIn/index',
						})
						// }, 100);
					} else {
						alert('请在微信小程序中打开')
						// 页面会 重新加载(如:列表页 查看详情后会返回顶部)
						// this.$router.push(path);
					}
				} else if (val == '统计') {}
			},
			// 补卡申请按钮
			repairApply() {
				this.repairDialog = true
			},
			// 补卡申请确认
			repairConfirm(e) {
				if (this.repairForm.applyTime == null || this.repairForm.applyTime == '') {
					Toast('请选择补卡时间')
					this.repairDialog = true
					return false
				} else {
					addRepairApply({
						applyUserId: this.userId,
						companyId: this.companyId,
						platformId: this.platformId,
						applyReason: this.repairForm.applyReason,
						applyTime: this.day + ' ' + this.repairForm.applyTime,
					}).then((res) => {
						if (res.code == 200) {
							this.getStatisticsByDay()
							this.getClockInByUserId()
							this.getRepairApply()
							this.getRepairApplyNum()
							Toast.success('已提交申请，请等待审核')
							this.repairDialog = false
						} else {
							Toast(res.msg)
						}
					})
				}
			},
			// 申请的补卡记录
			getRepairApply() {
				getRepairApplyList({
					applyUserId: this.userId,
					applyDate: this.day
				}).then((res) => {
					if (res.code == 200) {
						this.repairList = res.data
					} else {
						Toast(res.msg)
					}
				})
			},
			// 获取剩余补卡次数
			getRepairApplyNum() {
        let params={
          userId:this.userId,
          applyTime:this.day
        }
				getRepairApplyNum(params).then((res) => {
					if (res.code == 200) {
						this.repairApplyNum = res.data.remainNum
					} else {
						Toast(res.msg)
					}
				})
			},
		},
		created() {
			console.log(this.$route.params)
			this.companyName = this.$route.params.companyName
			this.platformId = this.$route.params.platformId
			this.userId = this.$route.params.userId
			this.companyId = this.$route.params.companyId
		},
		mounted() {
			// this.gotoUrl();
			this.getNowTimeFun()
			this.getUserInfo()
			this.getToday()
			this.initDate()
      this.getRepairApplyNum()
			this.isLoading = false
		},
		beforeDestroy() {
			clearInterval(this.timer)
			this.timer = null
		},
	}
</script>

<style scoped>
	.contain {
		background-color: #f2f4f5;
		min-height: 100vh;
	}

	.box {
		width: 92%;
		margin: auto;
		background: #ffffff;
		border-radius: 12px;
		overflow: hidden;
		margin-top: 21px;
		height: 80vh;
		position: relative;
	}

	.logo {
		width: 28px;
		height: 25px;
		margin: auto;
		display: block;
		margin-bottom: 10px;
	}

	.circle {
		width: 135px;
		height: 135px;
		margin: auto;
		display: block;
	}

	.title {
		font-family: PingFang SC;
		font-weight: 500;
		font-size: 20px;
		color: #242e3a;
		text-align: center;
	}

	.des {
		font-size: 13px;
	}

	.button {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.button-title {
		color: #ffffff;
	}

	.button-des {
		font-size: 15px;
		color: #ffffff;
		opacity: 0.6;
	}

	.item {
		background-color: #ededee;
		border-radius: 8px;
		box-sizing: border-box;
		padding: 9px 10px;
		width: 42vw;
	}

	.sTitle {
		font-family: PingFang SC;
		font-weight: 500;
		font-size: 13px;
		color: #5c636b;
		margin-left: 5px;
	}

	/deep/ .hash-calendar {
		border-radius: 12px;
	}

	/deep/ .calendar_title {
		box-sizing: border-box;
		padding: 10px;
	}

	/deep/ .calendar_week .calendar_item {
		font-family: PingFang SC;
		font-weight: 500;
		font-size: 10px !important;
		color: #888e94;
	}

	/deep/ .calendar_group .calendar_item {
		font-family: PingFang SC;
		font-weight: 500;
		font-size: 13px !important;
		color: #0e1824;
	}

	.action {
		display: flex;
		width: 100%;
		justify-content: space-between;
		align-items: center;
	}

	.now {
		font-family: PingFang SC;
		font-weight: bold;
		font-size: 15px;
		color: #17191c;
		display: flex;
		align-items: center;
	}

	.shu {
		display: inline-block;
		width: 1px;
		height: 22px;
		background-color: #cccdcf;
		font-weight: normal;
		margin: 0 10px;
	}

	.today {
		font-size: 13px;
		color: #888e94;
		font-family: PingFang SC;
	}

	.cardList {
		border-top: 1px solid #f0f0f1;
		box-sizing: border-box;
		margin: 10px 18px;
		overflow: hidden;
	}

	/deep/ .el-timeline-item__node {
		background-color: #aeaeb1;
		width: 8px;
		height: 8px;
	}

	/deep/ .el-timeline-item {
		padding-bottom: 36px;
	}

	/deep/ .el-timeline-item__dot {
		/* left: -13px; */
	}

	/deep/ .el-timeline-item__tail {
		top: 14px;
		height: 79%;
		left: 2px;
	}

	.clockTime {
		font-family: PingFang SC;
		font-weight: bold;
		font-size: 18px;
		color: #17191c;
	}

	.clockType {
		font-family: PingFang SC;
		font-weight: 400;
		font-size: 15px;
		color: #757b82;
		margin-top: 4px;
	}

	/deep/ .el-timeline-item__wrapper {
		top: -10px;
	}

	/deep/ .applyReason .van-cell__value {
		border: 1px solid #dcdfe6 !important;
		padding: 0 5px;
		border-radius: 4px;
	}

	.clockTime .status {
		padding-left: 5px;
		font-size: 14px;
		color: #757b82;
		font-weight: 400;
	}
</style>
